<template>
<div>
  <card>
    <h4 slot="title">{{position!=='1001'?'总体经营概况':'销售看板'}}</h4>
    <div v-if="position!=='1001'">

      <div class="name">
        <span>整体经营数据</span>
        <select-month @search="management" ref="management"></select-month>

      </div>
      <div class="cards">
        <Row  :gutter="12" class="cards">
          <Col v-for="(item) in managementData" style="min-width:143px"
               :key="item.name"
               span="12" :md="8" :lg="3">
            <data-item class="card" :data="item"></data-item>
          </Col>
        </Row>
      </div>

    </div>

    <div v-if="false&&position==='1001'">
      <div class="name">
        <span>项目经营数据</span>
        <select-month @search="projectManagement" ref="projectManagement"></select-month>

      </div>
      <div class="cards">
        <Row  :gutter="12" class="cards">
          <Col v-for="(item) in projectManagementData"
               :key="item.name"
               style="min-width:143px"   span="12" :md="8" :lg="3">
            <data-item class="card" :data="item"></data-item>
          </Col>
        </Row>
      </div>

    </div>


    <div class="name">
      <span>新签转化</span>
      <select-range @search="signTranslation" ref="signTranslation"></select-range>

    </div>
    <div class="cards">
      <Row  :gutter="12" class="cards">
        <Col v-for="(item) in signTranslationData" style="min-width:143px"
             :key="item.name"
             span="12" :md="8" :lg="3">
          <data-item class="card" :data="item"></data-item>
        </Col>
      </Row>
    </div>

    <div style="text-align: right;margin-bottom:30px">
<!--      v-if="position!=='1001'"-->
      <a href="JavaScript:void(0)"  @click.stop="toDashBoard">查看更多 >></a>
<!--      <a href="JavaScript:void(0)" v-else @click.stop="toWorkBench">去处理 >></a>-->
    </div>

    <!-- 库存看板 -->
    <div class="name">
      <span>库存看板</span>
      <!-- <select-range @search="stock" ref="stock"></select-range> -->
    </div>
    <div class="cards">
      <Row  :gutter="12" class="cards">
        <Col v-for="(item) in stockData" style="min-width:143px"
             :key="item.name"
             span="12" :md="8" :lg="3">
          <data-item class="card" :data="item"></data-item>
        </Col>
      </Row>
    </div>
  </card>

</div>
</template>

<script>
  import SelectMonth from './SelectMonth'
  import SelectRange from './SelectRange'
  import DataItem from './DataItem'
  import Card from './Card'
  import {management,projectManagement,signTranslation,stock} from "../../../api/homepage";
  import {mapState} from 'vuex'

  export default {
    name: "Overview",
    components:{
      Card,
      DataItem,
      SelectMonth,
      SelectRange
    },
    props:{
      projectFid:{
        type:String,
        default:''
      },
      projectFidList:{
        type:Array,
        default(){
          return []
        }
      }
    },
    computed:{
      ...mapState({
        position:state=>state.user.position
      })

    },
    watch:{
      projectFidList:{
        deep:true,
        handler(){
          this.$refs['signTranslation'] &&  this.signTranslation(this.$refs['signTranslation'].searchParams)
          // this.$refs['stock'] &&  this.stock(this.$refs['stock'].searchParams)
          this.$refs['management'] && this.management(this.$refs['management'].searchParams)
          this.$refs['projectManagement'] && this.projectManagement(this.$refs['projectManagement'].searchParams)
          this.stock();
        }
      }
    },
    created(){
      this.stock();
    },
    data(){
      return {
        managementData:[],
        projectManagementData:[],
        signTranslationData:[],
        stockData:[],
        managementT:null,
        projectManagementT:null,
        signTranslationT:null,
        stockT:null,
        year : new Date().getFullYear(),
        month : new Date().getMonth()+1,
        day: new Date().getDate(),
      }
    },
    methods:{
      toWorkBench(){
        this.$router.push({name:'workbench'})

      },
      toDashBoard(){
        this.$router.push({name:'operateboard',params:{targetTab:'1'}})
      },
      signTranslation(data){
        const params={
          projectFidList:this.projectFidList,
          ...data
        }
        clearTimeout(this.signTranslationT)
        this.signTranslationT=setTimeout(()=>{
          signTranslation(params).then(res=>{
            if(!res.data){
              this.signTranslationData=[]
              return

            }
            this.signTranslationData=res.data

          }).catch(()=>{
            return
          })

        },400)

      },
      stock(){
        const params={
          projectFidList:this.projectFidList,
          startDate: `${this.year}.${this.month}.${this.day}`,
          endDate:`${this.year}.${this.month}.${this.day}`
        }
        clearTimeout(this.stockT)
        this.stockT=setTimeout(()=>{
          stock(params).then(res=>{
            if(!res.data){
              this.stockData=[]
              return

            }
            this.stockData=res.data

          }).catch(error=>{
            console.log(error)
          })

        },400)
      },
      projectManagement(data){
        if(!this.projectFidList){
          return
        }
        const params={
          projectFidList:this.projectFidList,
          ...data
        }
        clearTimeout(this.projectManagementT)
        this.projectManagementT=setTimeout(()=>{
          projectManagement(params).then(res=>{
            if(!res.data){
              this.projectManagementData=[]
              return

            }
            this.projectManagementData=res.data

          }).catch(()=>{
            return
          })

        },400)

      },
      management(data){
        const params={
          projectFidList:this.projectFidList,
          ...data
        }
        clearTimeout(this.managementT)
        this.managementT=setTimeout(()=>{
          management(params).then(res=>{
            if(!res.data){
              this.managementData=[]
              return

            }
            this.managementData=res.data

          }).catch(()=>{
            return
          })

        },400)

      }
    }

  }
</script>

<style scoped>
  .name{
    color:rgba(73,80,96,1);
    font-weight:500;
    padding-bottom: 15px;

    border-bottom: 1px solid #ECECEC;
    margin-bottom: 17px;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .cards{
    margin-bottom: 10px;
    /*padding: 17px 0 ;*/
  }

</style>
